export const NON_BREAKING_SPACE = '\u00A0';
export const EM_DASH = '\u2014';
export const NON_BREAKING_DASH = '\u2011';
export const OP_BR = '«';
export const CL_BR = '»';
